import _ from 'lodash';

const Palette = {};

// Vejle BK
Palette.team8231 = {
    color: '#DB000F',
    shirtNumber: '#FFFFFF',
    stats: '#FFFFFF',
    gkShirtNumber: '#fff',
};
// Vendsyssel FF
Palette.team8615 = {
    color: '#F1F7F6',
    shirtNumber: '#000C6B',
    stats: '#000C6B',
    gkShirtNumber: '#fff',
};

// Esbjerg fB
Palette.team8285 = {
    color: '#2F73C4',
    shirtNumber: '#FFFFFF',
    stats: '#FFFFFF',
    gkShirtNumber: '#FFFFFF',
};

Palette.team8470 = {
    color: '#B13040',
    stats: '#ffffff',
    shirtNumber: '#B13040',
    gkShirtNumber: '#e5eae8',
};

// Viborg FF
Palette.team9939 = {
    color: '#006A5D',
    stats: '#FFFFFF',
    shirtNumber: '#FFFFFF',
    gkShirtNumber: '#EC0821',
};

Palette.team9814 = {
    color: '#efc80c',
    stats: '#1e1c13',
    shirtNumber: '#1e1c13',
    gkShirtNumber: '#e0e4e3',
};

Palette.team8071 = {
    color: '#f7f7f7',
    stats: '#303c5a',
    shirtNumber: '#303c5a',
    gkShirtNumber: '#e9e2e3',
};

Palette.team8595 = {
    color: '#f5eb3a',
    stats: '#24577c',
    shirtNumber: '#24577c',
    gkShirtNumber: '#862a33',
};

Palette.team8391 = {
    color: '#f7f7f7',
    stats: '#285b88',
    shirtNumber: '#285b88',
    gkShirtNumber: '#e8f2ee',
};
Palette.team9843 = {
    color: '#b5dcf3',
    stats: '#1d1d1d',
    shirtNumber: '#1d1d1d',
    gkShirtNumber: '#f4ebec',
};

Palette.team8113 = {
    color: '#0c0c0c',
    stats: '#ea0909',
    shirtNumber: '#ea0909',
    gkShirtNumber: '#10130c',
};

Palette.team10202 = {
    color: '#e60b0b',
    stats: '#f9eeee',
    shirtNumber: '#f9eeee',
    gkShirtNumber: '#f2ece8',
};

Palette.team9950 = {
    color: '#f4cd3e',
    stats: '#1c1b13',
    shirtNumber: '#1c1b13',
    gkShirtNumber: '#131313',
};

Palette.team9907 = {
    color: '#0a43aa',
    stats: '#eff1f6',
    shirtNumber: '#eff1f6',
    gkShirtNumber: '#eaeaea',
};

Palette.team8414 = {
    color: '#f7f7f7',
    stats: '#1d64a5',
    shirtNumber: '#1d64a5',
    gkShirtNumber: '#eaeaea',
};

Palette.team8410 = {
    color: '#92bcec',
    stats: '#f3f5f8',
    shirtNumber: '#f3f5f8',
    gkShirtNumber: '#Ecf1ef',
};

Palette.team8415 = {
    color: '#f70b24',
    stats: '#f8eced',
    shirtNumber: '#f8eced',
    gkShirtNumber: '#191a15',
};

Palette.team8487 = {
    color: '#9dacc9',
    stats: '#f2f3f5',
    shirtNumber: '#f2f3f5',
    gkShirtNumber: '#16130a',
};

Palette.team9825 = {
    color: '#ca0826',
    stats: '#ffffff',
    shirtNumber: '#ffffff',
    gkShirtNumber: '#e2e5e6',
}; //

Palette.team8678 = {
    color: '#f91b32',
    stats: '#161616',
    shirtNumber: '#faeff0',
    gkShirtNumber: '#10110a',
}; //	#f91b32	#161616	#faeff0	#10110a
Palette.team10204 = {
    color: '#0f44de',
    stats: '#ebedf5',
    shirtNumber: '#ebedf5',
    gkShirtNumber: '#130c07',
}; //	#0f44de	#ebedf5	#ebedf5	#130c07
Palette.team8191 = {
    color: '#6d2d37',
    stats: '#bfdde8',
    shirtNumber: '#bfdde8',
    gkShirtNumber: '#361b0e',
}; //	#6d2d37	#bfdde8	#bfdde8	#361b0e
Palette.team8455 = {
    color: '#0b4c9f',
    stats: '#ffffff',
    shirtNumber: '#ffffff',
    gkShirtNumber: '#f5ece9',
}; //	#0b4c9f	#ffffff	#ffffff	#f5ece9
Palette.team9826 = {
    color: '#2d62bb',
    stats: '#edeff4',
    shirtNumber: '#edeff4',
    gkShirtNumber: '#333334',
}; //	#2d62bb	#edeff4	#edeff4	#333334
Palette.team8668 = {
    color: '#193c97',
    stats: '#eceef2',
    shirtNumber: '#eceef2',
    gkShirtNumber: '#f4ebeb',
}; //	#193c97	#eceef2	#eceef2	#f4ebeb
Palette.team9796 = {
    color: '#f7f7f7',
    stats: '#106dbe',
    shirtNumber: '#1e1e1e',
    gkShirtNumber: '#ededed',
}; //	#f7f7f7	#106dbe	#1e1e1e	#ededed
Palette.team8197 = {
    color: '#0f4f98',
    stats: '#eceef2',
    shirtNumber: '#eceef2',
    gkShirtNumber: '#ececec',
}; //	#0f4f98	#eceef2	#eceef2	#ececec
Palette.team8650 = {
    color: '#c8252c',
    stats: '#f5eded',
    shirtNumber: '#f5eded',
    gkShirtNumber: '#e7edea',
}; //	#c8252c	#f5eded	#f5eded	#e7edea
Palette.team8456 = {
    color: '#91c3e7',
    stats: '#2a3545',
    shirtNumber: '#2a3545',
    gkShirtNumber: '#eaf2ef',
}; //	#91c3e7	#2a3545	#2a3545	#eaf2ef
Palette.team10260 = {
    color: '#de1b37',
    stats: '#f6ecee',
    shirtNumber: '#f6ecee',
    gkShirtNumber: '#ebebec',
}; //	#de1b37	#f6ecee	#f6ecee	#ebebec
Palette.team10261 = {
    color: '#181818',
    stats: '#e5465d',
    shirtNumber: '#e5465d',
    gkShirtNumber: '#0d1415',
}; //	#181818	#e5465d	#e5465d	#0d1415

//#eeeeee	#ae2a3b	#ae2a3b	#131007
Palette.team8466 = {
    color: '#eeeeee',
    stats: '#ae2a3b',
    shirtNumber: '#ae2a3b',
    gkShirtNumber: '#131007',
}; //	#eeeeee	#ae2a3b	#ae2a3b	#131007
Palette.team10194 = {
    color: '#f5f5f5',
    stats: '#e11f1f',
    shirtNumber: '#e11f1f',
    gkShirtNumber: '#e9e7eb',
}; //	#f5f5f5	#e11f1f	#e11f1f	#e9e7eb
Palette.team10003 = {
    color: '#f7f7f7',
    stats: '#212121',
    shirtNumber: '#212121',
    gkShirtNumber: '#0f1212',
}; //	#f7f7f7	#212121	#212121	#0f1212
Palette.team8586 = {
    color: '#f7f7f7',
    stats: '#2f618d',
    shirtNumber: '#2f618d',
    gkShirtNumber: '#15130b',
}; //	#f7f7f7	#2f618d	#2f618d	#15130b
Palette.team9817 = {
    color: '#f4de6b',
    stats: '#863d3f',
    shirtNumber: '#863d3f',
    gkShirtNumber: '#e8f0f2',
}; //	#f4de6b	#863d3f	#863d3f	#e8f0f2
Palette.team8659 = {
    color: '#2a3a64',
    stats: '#edeeef',
    shirtNumber: '#edeeef',
    gkShirtNumber: '#0b130d',
}; //	#2a3a64	#edeeef	#edeeef	#0b130d
Palette.team8654 = {
    color: '#6d293a',
    stats: '#f0edee',
    shirtNumber: '#f0edee',
    gkShirtNumber: '#14150d',
}; //	#6d293a	#f0edee	#f0edee	#14150d

// bundesliga
Palette.team8177 = { color: '#005ca9', stats: ' #ffffff', shirtNumber: '#486190', gkShirtNumber: '#000' };
Palette.team8178 = { color: '#1a171b', stats: ' #e32221', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8226 = { color: '#1c63b7', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8358 = { color: '#000000', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8406 = { color: '#ba3733', stats: ' #ffffff', shirtNumber: '#ba3733', gkShirtNumber: '#fff' };
Palette.team8697 = { color: '#19694e', stats: ' #ffffff', shirtNumber: '#50e16a', gkShirtNumber: '#000' };
Palette.team8721 = { color: '#65b32e', stats: ' #ffffff', shirtNumber: '#2747B8', gkShirtNumber: '#ffffff' };
Palette.team8722 = { color: '#f7f7f7', stats: ' #ed1c24', shirtNumber: '#ed1c24', gkShirtNumber: '#ed1c24' };
Palette.team9788 = { color: '#f7f7f7', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team9789 = { color: '#fde100', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team9790 = { color: '#376aaa', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9810 = { color: '#f7f7f7', stats: ' #454545', shirtNumber: '#fff', gkShirtNumber: '#454545' };
Palette.team9823 = { color: '#ed1248', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9904 = { color: '#179d33', stats: ' #000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9905 = { color: '#ed1c24', stats: ' #000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team10189 = { color: '#0060a9', stats: ' #f7f7f7', shirtNumber: '#f7f7f7', gkShirtNumber: '#f7f7f7' };
Palette.team10269 = { color: '#ffffff', stats: ' #e32219', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team178475 = { color: '#f7f7f7', stats: ' #dd0741', shirtNumber: '#dd0741', gkShirtNumber: '#dd0741' };
Palette.team2004 = { color: '#171415', stats: ' #c51218', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team6238 = { color: '#a4c6e9', stats: ' #000000', shirtNumber: '#1f1916', gkShirtNumber: '#1f1916' };
Palette.team6694 = { color: '#005aa1', stats: ' #d9d9d9', shirtNumber: '#d9d9d9', gkShirtNumber: '#d9d9d9' };
Palette.team8014 = { color: '#f4d910', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8248 = { color: '#00963a', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8310 = { color: '#172981', stats: ' #fed200', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8349 = { color: '#00080d', stats: ' #ffee00', shirtNumber: '#ffee00', gkShirtNumber: '#ffee00' };
Palette.team8359 = { color: '#0a4987', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8428 = { color: '#fcd200', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8449 = { color: '#f7f7f7', stats: ' #194d99', shirtNumber: '#194d99', gkShirtNumber: '#194d99' };
Palette.team8510 = { color: '#006039', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8527 = { color: '#f7f7f7', stats: ' #1a171b', shirtNumber: '#1a171b', gkShirtNumber: '#1a171b' };
Palette.team9802 = { color: '#3dbaf0', stats: ' #0e305d', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9892 = { color: '#db001b', stats: ' #f7f7f7', shirtNumber: '#f7f7f7', gkShirtNumber: '#f7f7f7' };
Palette.team9893 = { color: '#0062ac', stats: ' #fabc00', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team10237 = { color: '#b2d1ed', stats: ' #13191e', shirtNumber: '#13191e', gkShirtNumber: '#13191e' };
Palette.team7988 = { color: '#000000', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8007 = { color: '#3e407b', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8180 = { color: '#1f227a', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8404 = { color: '#f8941a', stats: ' #003d60', shirtNumber: '#003d60', gkShirtNumber: '#003d60' };
Palette.team8422 = { color: '#ffffff', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8468 = { color: '#e31a22', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8476 = { color: '#f7db13', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8478 = { color: '#e83646', stats: ' #fff506', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8509 = { color: '#2747a3', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8512 = { color: '#e9e9e9', stats: ' #264a90', shirtNumber: '#264a90', gkShirtNumber: '#264a90' };
Palette.team8605 = { color: '#081d58', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8608 = { color: '#ed1c24', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8609 = { color: '#144f94', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8616 = { color: '#f7c92a', stats: ' #000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team9917 = { color: '#176fc1', stats: ' #ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9918 = { color: '#182c56', stats: ' #ca902b', shirtNumber: '#ca902b', gkShirtNumber: '#ca902b' };

Palette.team8560 = { color: '#0a42a3', stats: '#fafafa', shirtNumber: '#fafafa', gkShirtNumber: '#09140d' };
Palette.team8634 = { color: '#185493', stats: '#E5A409', shirtNumber: '#f6dc40', gkShirtNumber: '#ea6d41' };
Palette.team9866 = { color: '#1b3dc0', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8315 = { color: '#fafafa', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team9906 = { color: '#ea2441', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9910 = { color: '#93bdd2', stats: '#9e2d35', shirtNumber: '#9e2d35', gkShirtNumber: '#efe7e7' };
Palette.team9783 = { color: '#0054a0', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
Palette.team8372 = { color: '#a33031', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
Palette.team8558 = { color: '#1b68a5', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
Palette.team8305 = { color: '#4a8ac1', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
Palette.team7732 = { color: '#cf2a31', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8306 = { color: '#ebcd22', stats: '#00489f', shirtNumber: '#00489f', gkShirtNumber: '#ebcd22' };
Palette.team7854 = { color: '#1283D6', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8581 = { color: '#11497E', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9864 = { color: '#1B6CBD', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8603 = { color: '#23956a', stats: '#ffffff', shirtNumber: '#23956a', gkShirtNumber: '#000000' };
Palette.team8633 = { color: '#f8f8f8', stats: '#2AAFD0', shirtNumber: '#2AAFD0', gkShirtNumber: '#ffffff' };
Palette.team8302 = { color: '#f8f8f8', stats: '#F5364D', shirtNumber: '#F5364D', gkShirtNumber: '#fff' };
Palette.team10267 = { color: '#000000', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team10205 = { color: '#F6E255', stats: '#1d1c15', shirtNumber: '#1d1c15', gkShirtNumber: '#000000' };

Palette.team674792 = { color: '#000', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#fff' };
Palette.team9891 = { color: '#FFE200', stats: '#0275BB', shirtNumber: '#0275BB', gkShirtNumber: '#0275BB' };
Palette.team8534 = { color: '#0261A6', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#fff' };
Palette.team8587 = { color: '#F5F5F5', stats: '#000', shirtNumber: '#000', gkShirtNumber: '#fff' };
Palette.team9837 = { color: '#D83E43', stats: '#fff', shirtNumber: '#D83E43', gkShirtNumber: '#000' };
Palette.team6394 = { color: '#E70812', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#000' };
Palette.team9851 = { color: '#E53B2C', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#000' };
Palette.team8592 = { color: '#02A7E0', stats: '#fff', shirtNumber: '#02A7E0', gkShirtNumber: '#fff' };
Palette.team8121 = { color: '#fff', stats: '#000', shirtNumber: '#000', gkShirtNumber: '#000' };
Palette.team9830 = { color: '#FFDB00', stats: '#1C9A42', shirtNumber: '#1C9A42', gkShirtNumber: '#fff' };
Palette.team96925 = { color: '#251F82', stats: '#fff', shirtNumber: '#fff', gkShirtNumber: '#000' };
Palette.team10281 = { color: '#9D1B93', stats: '#fff', shirtNumber: '#000', gkShirtNumber: '#000' };
Palette.team8370 = { color: '#fff', stats: '#D33D2E', shirtNumber: '#000', gkShirtNumber: '#fff' };

Palette.team8686 = { color: '#A92030', stats: '#FBB300', shirtNumber: '#FBB300', gkShirtNumber: '#FBB300' };
Palette.team9876 = { color: '#252b4f', stats: '#e9c714', shirtNumber: '#e9c714', gkShirtNumber: '#ffffff' };
Palette.team10252 = { color: '#A4345F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8283 = { color: '#D42327', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8658 = { color: '#003593', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8559 = { color: '#E8E4EC', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team9937 = { color: '#B1021F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8427 = { color: '#D6313F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9792 = { color: '#F2DA29', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8344 = { color: '#253F9F', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team10170 = { color: '#ECECEC', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team9879 = { color: '#ECECEC', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8667 = { color: '#F59A15', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team9902 = { color: '#2C4EDD', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8463 = { color: '#E4E4E4', stats: '#2A4B9F', shirtNumber: '#2A4B9F', gkShirtNumber: '#ffffff' };
Palette.team8549 = { color: '#C50007', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team10004 = { color: '#1E3979', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9850 = { color: '#FFF916', stats: '#00795E', shirtNumber: '#00795E', gkShirtNumber: '#ffffff' };
Palette.team10203 = { color: '#FF312C', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8411 = { color: '#DFDFDF', stats: '#001B5B', shirtNumber: '#001B5B', gkShirtNumber: '#ffffff' };
Palette.team10172 = { color: '#F3FAFF', stats: '#CD2E37', shirtNumber: '#1E78CE', gkShirtNumber: '#ffffff' };
Palette.team9798 = { color: '#F1F1F1', stats: '#941614', shirtNumber: '#2A4EA5', gkShirtNumber: '#ffffff' };
Palette.team8657 = { color: '#CC1B21', stats: '#000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team10163 = { color: '#506BEB', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8472 = { color: '#F00F19', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8602 = { color: '#FF9D29', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };

Palette.team8564 = { color: '#B3131C', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8524 = { color: '#3467C6', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6266 = { color: '#E9CC64', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team9857 = { color: '#1A183D', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8529 = { color: '#20203E', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8533 = { color: '#F9E331', stats: '#174879', shirtNumber: '#174879', gkShirtNumber: '#000000' };
Palette.team9876 = { color: '#252B4F', stats: '#E9C714', shirtNumber: '#E9C714', gkShirtNumber: '#FFFFFF' };
Palette.team9884 = { color: '#061144', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#303443' };
Palette.team8535 = { color: '#492D6F', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8636 = { color: '#2863B2', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#F9F116' };
Palette.team9885 = { color: '#000000', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8543 = { color: '#A5CADD', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8686 = { color: '#8D2833', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#F29101' };
Palette.team9882 = { color: '#29439A', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team7943 = { color: '#278F5B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8547 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team9875 = { color: '#227AAA', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team9804 = { color: '#621827', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8600 = { color: '#505050', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team10233 = { color: '#911726', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };

Palette.team8454 = { color: '#D82432', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team9823 = { color: '#D32735', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };

Palette.teamMER = { color: '#00D2BE', stats: '#000000' };
Palette.teamFER = { color: '#DC0000', stats: '#FFFFFF' };
Palette.teamRBR = { color: '#00327D', stats: '#FFFFFF' };
Palette.teamFIN = { color: '#F596C8', stats: '#000000' };
Palette.teamWIL = { color: '#F6F6F6', stats: '#002E5E' };
Palette.teamREN = { color: '#FFF500', stats: '#000000' };
Palette.teamSTR = { color: '#0032FF', stats: '#FFFFFF' };
Palette.teamHAS = { color: '#5A5A5A', stats: '#FFFFFF' };
Palette.teamMCL = { color: '#FF8700', stats: '#000000' };
Palette.teamSAU = { color: '#9B0000', stats: '#DFE2E6' };

//china
Palette.team4177 = { color: '#2C7546', stats: '#D0C34D', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team6445 = { color: '#F97D47', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6401 = { color: '#8A292B', stats: '#F0D47B', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team4184 = { color: '#F83C40', stats: '#4161B0', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team256658 = { color: '#66B0E1', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team92646 = { color: '#BE2F37', stats: '#B28E58', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team7803 = { color: '#FFFFFF', stats: '#3A4C9E', shirtNumber: '#3A4C9E', gkShirtNumber: '#000000' };
Palette.team256659 = { color: '#FFFFFF', stats: '#CEC74E', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team525097 = { color: '#B0142C', stats: '#771E2C', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team51442 = { color: '#9B1627', stats: '#1C3F8D', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team167482 = { color: '#305BB1', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8623 = { color: '#E77D31', stats: '#305BB1', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6628 = { color: '#305BB1', stats: '#89081E', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team198616 = { color: '#A1192B', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team256660 = { color: '#E21D35', stats: '#4A030B', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team4189 = { color: '#FFFFFF', stats: '#305BB1', shirtNumber: '#305BB1', gkShirtNumber: '#000000' };
// wc
Palette.team6716 = { color: '#FDCA2E', stats: '#273A35', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8491 = { color: '#FFFFFF', stats: '#CD1F2D', shirtNumber: '#CD1F2D', gkShirtNumber: '#FFFFFF' };
Palette.team6706 = { color: '#FFFFFF', stats: '#CAD6E1', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8263 = { color: '#BA282D', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#20C47D' };
Palette.team8256 = { color: '#EFC54D', stats: '#419B69', shirtNumber: '#419B69', gkShirtNumber: '#FFFFFF' };
Palette.team8570 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team8238 = { color: '#CE0A25', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team10255 = { color: '#CE0A25', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6711 = { color: '#FFFFFF', stats: '#B2092C', shirtNumber: '#B2092C', gkShirtNumber: '#FFFFFF' };
Palette.team8536 = { color: '#0844AB', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6720 = { color: '#D82723', stats: '#E7C451', shirtNumber: '#E7C451', gkShirtNumber: '#000000' };
Palette.team8258 = { color: '#FDF04D', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#3ABB60' };
Palette.team6705 = { color: '#D1162F', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6262 = { color: '#FFFFFF', stats: '#D1162F', shirtNumber: '#D1162F', gkShirtNumber: '#000000' };
Palette.team6710 = { color: '#126E6A', stats: '#188E5B', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6346 = { color: '#FFFFFF', stats: '#C4DEB0', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team5922 = { color: '#AD1836', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team5798 = { color: '#FFFFFF', stats: '#A92129', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8568 = { color: '#B1333A', stats: '#922131', shirtNumber: '#c72b33', gkShirtNumber: '#FFFFFF' };
Palette.team8361 = { color: '#D4232F', stats: '#167A58', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8713 = { color: '#DA272C', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team7795 = { color: '#5AA95E', stats: '#fff', shirtNumber: '#5AA95E', gkShirtNumber: '#FFFFFF' };
Palette.team6395 = { color: '#FFFFFF', stats: '#1BA797', shirtNumber: '#1BA797', gkShirtNumber: '#FFFFFF' };
Palette.team8205 = { color: '#E63A39', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team6719 = { color: '#FFFFFF', stats: '#CC1018', shirtNumber: '#CC1018', gkShirtNumber: '#FFFFFF' };
Palette.team5796 = { color: '#7AA7CD', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6723 = { color: '#292E40', stats: '#2097CC', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team10165 = { color: '#FFFFFF', stats: '#DF243D', shirtNumber: '#DF243D', gkShirtNumber: '#FFFFFF' };
Palette.team6717 = { color: '#CE1932', stats: '#EC576C', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8520 = { color: '#E6DF66', stats: '#2F3A7D', shirtNumber: '#2F3A7D', gkShirtNumber: '#000000' };
Palette.team7804 = { color: '#F35C54', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#CEF16B' };
Palette.team6715 = { color: '#CEF16B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team10155 = { color: '#b92730', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
//fin
Palette.team6550 = { color: '#3971DC', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8424 = { color: '#000000', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team9861 = { color: '#336DC3', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6605 = { color: '#F0C72E', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team6634 = { color: '#FFFFFF', stats: '#137676', shirtNumber: '#137676', gkShirtNumber: '#FFFFFF' };
Palette.team162146 = { color: '#F0DC31', stats: '#148B6D', shirtNumber: '#148B6D', gkShirtNumber: '#F0DC31' };
Palette.team1693 = { color: '#F8E233', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team4672 = { color: '#FB142C', stats: '#246CBA', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team1576 = { color: '#1E68C7', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team162162 = { color: '#000000', stats: '#9F8465', shirtNumber: '#9F8465', gkShirtNumber: '#000000' };
Palette.team6633 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team6597 = { color: '#000000', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team10252 = { color: '#780B47', stats: '#B4CDE7', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
//champ
Palette.team8283 = { color: '#DD3847', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
Palette.team8658 = { color: '#003E9A', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8559 = { color: '#F9F9F9', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team9937 = { color: '#E90D37', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#20C47D' };
Palette.team8427 = { color: '#E73144', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team9792 = { color: '#F4D747', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8344 = { color: '#2D4694', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#2D4694' };
Palette.team10170 = { color: '#F9F9F9', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#137F94' };
Palette.team9879 = { color: '#F9F9F9', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8667 = { color: '#FBB95A', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team9902 = { color: '#2845C4', stats: '#000000', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team10172 = { color: '#000000', stats: '#0E62BA', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8463 = { color: '#F9F9F9', stats: '#B3914F', shirtNumber: '#B3914F', gkShirtNumber: '#235084' };
Palette.team8549 = { color: '#CD0C23', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#5BCA7D' };
Palette.team10004 = { color: '#212E4E', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team9850 = { color: '#FEE857', stats: '#1FCB80', shirtNumber: '#1FCB80', gkShirtNumber: '#ffffff' };
Palette.team10203 = { color: '#FC333E', stats: '#F9F9F9', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8411 = { color: '#ffffff', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team9798 = { color: '#F9F9F9', stats: '#083DAD', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8472 = { color: '#DB0B2D', stats: '#ffffff', shirtNumber: '#000000', gkShirtNumber: '#2D69C7' };
Palette.team8602 = { color: '#F8872A', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team10163 = { color: '#3050B5', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#000000' };
Palette.team8657 = { color: '#C00718', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#ffffff' };
Palette.team8119 = { color: '#DD0301', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8528 = { color: '#0350C1', stats: '#ffffff', shirtNumber: '#ffffff', gkShirtNumber: '#ffffff' };
Palette.team8655 = { color: '#ffffff', stats: '#282B90', shirtNumber: '#282B90', gkShirtNumber: '#ffffff' };
// bund
Palette.team9912 = { color: '#294FB4', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team9911 = { color: '#1776C4', stats: '#0F2D69', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8262 = { color: '#1466C5', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8293 = { color: '#FFFFFF', stats: '#2352B8', shirtNumber: '#2352B8', gkShirtNumber: '#000000' };
Palette.team8480 = { color: '#FBAE3A', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team9776 = { color: '#F8C84F', stats: '#2F649A', shirtNumber: '#2F649A', gkShirtNumber: '#000000' };
Palette.team8319 = { color: '#3A2B8D', stats: '#F2C88A', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team94937 = { color: '#B90A25', stats: '#000000', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8194 = { color: '#FFFFFF', stats: '#F11F25', shirtNumber: '#F11F25', gkShirtNumber: '#0C5968' };
Palette.team8357 = { color: '#FFFFFF', stats: '#137730', shirtNumber: '#137730', gkShirtNumber: '#FFFFFF' };
Palette.team8150 = { color: '#175AA9', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#175AA9' };
Palette.team7789 = { color: '#FFFFFF', stats: '#EB2127', shirtNumber: '#EB2127', gkShirtNumber: '#FFFFFF' };
Palette.team8350 = { color: '#AC0728', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8086 = { color: '#3F3B49', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8152 = { color: '#3F3B49', stats: '#E0334C', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8149 = { color: '#FFFFFF', stats: '#E5253A', shirtNumber: '#E5253A', gkShirtNumber: '#FFFFFF' };
Palette.team8234 = { color: '#DB1927', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8165 = { color: '#9B2231', stats: '#484452', shirtNumber: '#fff', gkShirtNumber: '#fff' };

Palette.team5797 = { color: '#407950', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6329 = { color: '#104D9D', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6317 = { color: '#4F895F', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team6714 = { color: '#FFFFFF', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8700 = { color: '#184680', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team5884 = { color: '#102095', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team5884 = { color: '#DB0B0B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8254 = { color: '#EEC200', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team5866 = { color: '#FFFFFF', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8566 = { color: '#103F95', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team5795 = { color: '#95001B', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team9762 = { color: '#C60606', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };

Palette.team9829 = { color: '#b80010', stats: '#FFFFFF', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team8342 = { color: '#0177bf', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8640 = { color: '#FFFFFF', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#000000' };
Palette.team9847 = { color: '#151e2d', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team8687 = { color: '#A5010B', stats: '#f5bc4e', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team9773 = { color: '#00a6f0', stats: '#FFFFFF', shirtNumber: '#00a6f0', gkShirtNumber: '#FFFFFF' };
Palette.team8637 = { color: '#c5022f', stats: '#ffb900', shirtNumber: '#c5022f', gkShirtNumber: '#FFFFFF' };
Palette.team8710 = { color: '#009f4b', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8593 = { color: '#d50032', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team8563 = { color: '#f5c308', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };
Palette.team9772 = { color: '#FFFFFF', stats: '#c30000', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team9728 = { color: '#f27022', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#000000' };
Palette.team9748 = { color: '#14387f', stats: '#FFFFFF', shirtNumber: '#14387f', gkShirtNumber: '#FFFFFF' };
Palette.team6033 = { color: '#FF102C', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team9760 = { color: '#003990', stats: '#FFFFFF', shirtNumber: '#FFFFFF', gkShirtNumber: '#FFFFFF' };
Palette.team10192 = { color: '#ffcf00', stats: '#000000', shirtNumber: '#000000', gkShirtNumber: '#FFFFFF' };

Palette.team7787 = { color: '#D7141A', stats: '#fff', shirtNumber: '#D7141A', gkShirtNumber: '#FFFFFF' };

const colorForTeam = (team, color, def = '#fff') => {
    return _.get(Palette, `team${team}.${color}`, def);
};

export default Palette;

export { colorForTeam };



/** WEBPACK FOOTER **
 ** ../src/widgets/helpers/TeamColorProfile.js
 **/